import { render, staticRenderFns } from "./TosWindow.vue?vue&type=template&id=e309760e&scoped=true&"
import script from "./TosWindow.vue?vue&type=script&lang=js&"
export * from "./TosWindow.vue?vue&type=script&lang=js&"
import style0 from "@/assets/style/windowAkawaku.css?vue&type=style&index=0&id=e309760e&prod&scoped=true&lang=css&"
import style1 from "./TosWindow.vue?vue&type=style&index=1&id=e309760e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e309760e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDialog})
